import axios from '../axios'
// 搜索列表
export const getUserList = (data) => {
  return axios({
    url: '/con/manage/user/list',
    method: 'POST',
    data
  })
}
// 冻结账号
export const getUpdate_user_status = (data) => {
  return axios({
    url: '/con/manage/user/update_user_status',
    method: 'POST',
    data
  })
}
// 重置密码
export const Postreset_passwd = (data) => {
  return axios({
    url: '/con/manage/user/reset_passwd',
    method: 'POST',
    data
  })
}
// 查询所有角色
export const getAllRole = (data) => {
  return axios({
    url: '/con/manage/role/get_all_role',
    method: 'POST',
  })
}
// 添加账号
export const postAddAccount = (data) => {
  return axios({
    url: '/con/manage/user/save',
    method: 'POST',
    data
  })
}
// 删除账号
export const postDelete = (data) => {
  return axios({
    url: '/con/manage/user/delete',
    method: 'POST',
    data
  })
}












// WEBPACK FOOTER //
// ./src/http/moudules/accountManagement.js